const joinSecEl = document.querySelector('.join-us-sec');

if(joinSecEl) {
  const items = document.querySelectorAll(".join-us-sec__item");
  const images = document.querySelectorAll(".join-us-sec__image");

  const AUTOPLAY_DELAY = 3000;

  let activeIndex = 0;
  let autoplayTimer = null;
  let isHovering = false;

  function setActive(index) {
    items.forEach(item => item.classList.remove('is-active'));
    images.forEach(image => image.classList.remove('is-active'));

    if(items[index]) items[index].classList.add('is-active');
    if(images[index]) images[index].classList.add('is-active');

    activeIndex = index;
  }

  function nextSlide() {
    const nextIndex = (activeIndex + 1) % items.length;
    setActive(nextIndex);
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setTimeout(() => {
      if(!isHovering) {
        nextSlide();
        startAutoplay();
      }
    }, AUTOPLAY_DELAY);
  }

  function stopAutoplay() {
    if(autoplayTimer) {
      clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }
  }

  setActive(0);

  startAutoplay();

  const isMobile = () => window.innerWidth <= 1024;

  items.forEach((item, index) => {
    item.addEventListener('mouseenter', () => {
      if(!isMobile()) {
        isHovering = true;
        stopAutoplay();
        setActive(index);
      }
    });

    item.addEventListener('mouseleave', () => {
      if(!isMobile()) {
        isHovering = false;
        startAutoplay();
      }
    });

    item.addEventListener('click', (e) => {
      if(isMobile()) {
        e.preventDefault();
        stopAutoplay();
        setActive(index);
        startAutoplay();
      } else {
        setActive(index);
        stopAutoplay();
        startAutoplay();
      }
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      stopAutoplay();
      startAutoplay();
    }, 250);
  });
}